import React from "react";
import {
  Box,
  HStack,
  SimpleGrid,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";

export default function PublicProfileSkeleton() {
  const cardBg = useColorModeValue("white", "gray.700");
  const headerBg = useColorModeValue("gray.200", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");

  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };

  return (
    <>
      {/* Profile Header Card */}
      <Box bg={cardBg} rounded="lg" boxShadow="sm" p={6} display="flex" flexDirection="column" alignItems="center">
        <Skeleton height="24px" width="180px" mb={2} {...skeletonProps} />
        <Skeleton height="12px" width="100px" mb={2} {...skeletonProps} />
        <Skeleton height="20px" width="160px" borderRadius="full" {...skeletonProps} />
      </Box>

      {/* Stats Card */}
      <Box bg={cardBg} rounded="lg" boxShadow="sm" p={5}>
        <Skeleton height="12px" width="120px" mb={4} {...skeletonProps} />
        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
          {Array.from({ length: 6 }).map((_, i) => (
            <Box key={i}>
              <Skeleton height="10px" width="70px" mb={2} {...skeletonProps} />
              <Skeleton height="20px" width="90px" {...skeletonProps} />
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      {/* Recent P&L Table Card */}
      <Box bg={cardBg} rounded="lg" boxShadow="sm" overflow="hidden">
        <Box p={5} pb={3}>
          <Skeleton height="12px" width="100px" mb={3} {...skeletonProps} />
        </Box>
        <HStack bg={headerBg} px={4} py={2} spacing={6}>
          {[60, 50, 50].map((w, i) => (
            <Skeleton key={i} height="12px" width={`${w}px`} flexShrink={0} {...skeletonProps} />
          ))}
        </HStack>
        {Array.from({ length: 5 }).map((_, row) => (
          <HStack key={row} px={4} py={3} spacing={6} borderTopWidth="1px" borderColor={borderColor}>
            {[70, 55, 35].map((w, col) => (
              <Skeleton key={col} height="12px" width={`${w + (row % 3) * 5}px`} flexShrink={0} {...skeletonProps} />
            ))}
          </HStack>
        ))}
      </Box>
    </>
  );
}
